import { siteConfig } from "@acme/config";
import { createFileRoute } from "@tanstack/react-router";
import { Capabilities } from "~/components/home/capabilities";
import { ClosingPanel } from "~/components/home/closing-panel";
import { Ecosystem } from "~/components/home/ecosystem";
import { Hero } from "~/components/home/hero";
import { OpeningScene } from "~/components/home/opening-scene";
import { StudioNote } from "~/components/home/studio-note";
import { Workbench } from "~/components/home/workbench";
import { usePageEngagement } from "~/hooks/use-page-engagement";
import { publicCacheHeaders } from "~/lib/cache-headers";
import { seo } from "~/lib/seo";
import {
  generateStructuredDataGraph,
  getHomepageSchemas,
} from "~/lib/structured-data";
import * as m from "~/paraglide/messages.js";

export const Route = createFileRoute("/(public)/")({
  component: Home,
  head: () => {
    const seoData = seo({
      description: m.meta_home_description(),
      keywords: siteConfig.keywords,
      path: "/",
      title: m.meta_home_title(),
    });
    const structuredData = generateStructuredDataGraph(getHomepageSchemas());
    return {
      links: seoData.links,
      meta: seoData.meta,
      scripts: [
        {
          children: structuredData,
          type: "application/ld+json",
        },
      ],
    };
  },
  headers: publicCacheHeaders,
  // No loader. The page carries no case study and no project band, so the LCP
  // route no longer waits on a database round trip.
});

function Home() {
  usePageEngagement({ pagePath: "/" });

  return (
    <>
      <OpeningScene>
        <Hero />
        <Workbench />
      </OpeningScene>
      <Ecosystem />
      <Capabilities />
      <StudioNote />
      <ClosingPanel />
    </>
  );
}
